const RelatedModel = require('./related_model')
// const getSpotlight = require('module/user/helpers/get_spotlight')
const getSpotlightData = require('module/user/helpers/get_spotlight_data')
const isCustomTextSpotlight = require('module/user/helpers/is_custom_text_spotlight')
const log = require('log').create('user', 'spotlight') // eslint-disable-line


const Spotlight = RelatedModel.extend({

    defaults: {
        type: null,
        text: null,
        url: null,
    },

    initialize(attrs) {
        this.listenTo(this, 'change:type', this.checkTextProperty)
    },

    checkTextProperty() {
        const type = this.get('type')
        const data = getSpotlightData({ type })
        if (! data) return
        if (! isCustomTextSpotlight(data)) {
            this.set('text', null)
        }
    },

    getMissingKeys(fields, attrs) {
        // map fields to their keys, and filter out those with no key
        const required = fields.map(field => field.key).filter(Boolean)
        return required.filter(key => ! attrs[key])
    },

    validators: {
        type(value, attrs) {
            // it's okay for type to be null/undefined
            if (! value) return

            // but if type is truthy, it needs to correspond to a valid spotlight
            const data = getSpotlightData({ type: value })
            if (! data) return 'Invalid spotlight type.'

            // and we should have all the values required by that spotlight type
            const missing = this.getMissingKeys(data.fields, attrs)
            if (missing.length) return `Missing keys: ${missing.join(', ')}`
        },
    },

})

module.exports = Spotlight
